import { TCoreTextStyleProps } from '@core/widgets';

type TTextStyle = {
    display1: TCoreTextStyleProps;
    display2: TCoreTextStyleProps;
    header: TCoreTextStyleProps;
    subheader: TCoreTextStyleProps;
    main: TCoreTextStyleProps;
    mCardNo: TCoreTextStyleProps;
    secondary: TCoreTextStyleProps;
    tag: TCoreTextStyleProps;
};

export type TSeparatorVariant = 'line' | 'subheader' | 'ShadowUp' | 'ShadowDown';

export type TSeparatorHierarchy = 'primary' | 'secondary';

export const TextStyle: TTextStyle = {
    display1: {
        font: 'var(--font-display1)',
        fontStyle: {
            fontSize: 'var(--typography-display1-size)',
            fontWeight: 'var(--typography-display1-weight)',
            lineHeight: 'var(--typography-display1-line-height)',
            letterSpacing: 'var(--typography-display1-spacing)',
        },
    },
    display2: {
        font: 'var(--font-display2)',
        fontStyle: {
            fontSize: 'var(--typography-display2-size)',
            fontWeight: 'var(--typography-display2-weight)',
            lineHeight: 'var(--typography-display2-line-height)',
            letterSpacing: 'var(--typography-display2-spacing)',
        },
    },
    header: {
        font: 'var(--font-header)',
        fontStyle: {
            fontSize: 'var(--typography-header-size)',
            fontWeight: 'var(--typography-header-weight)',
            lineHeight: 'var(--typography-header-line-height)',
            letterSpacing: 'var(--typography-header-spacing)',
        },
    },
    subheader: {
        font: 'var(--font-subheader)',
        fontStyle: {
            fontSize: 'var(--typography-subheader-size)',
            fontWeight: 'var(--typography-subheader-weight)',
            lineHeight: 'var(--typography-subheader-line-height)',
            letterSpacing: 'var(--typography-subheader-spacing)',
        },
    },
    main: {
        font: 'var(--font-main)',
        fontStyle: {
            fontSize: 'var(--typography-main-size)',
            fontWeight: 'var(--typography-main-weight)',
            lineHeight: 'var(--typography-main-line-height)',
            letterSpacing: 'var(--typography-main-spacing)',
        },
    },
    mCardNo: {
        font: 'var(--font-mCardNo)',
        fontStyle: {
            fontSize: 'var(--typography-mCardNo-size)',
            fontWeight: 'var(--typography-mCardNo-weight)',
            lineHeight: 'var(--typography-mCardNo-line-height)',
            letterSpacing: 'var(--typography-mCardNo-spacing)',
        },
    },
    secondary: {
        font: 'var(--font-secondary)',
        fontStyle: {
            fontSize: 'var(--typography-secondary-size)',
            fontWeight: 'var(--typography-secondary-weight)',
            lineHeight: 'var(--typography-secondary-line-height)',
            letterSpacing: 'var(--typography-secondary-spacing)',
        },
    },
    tag: {
        font: 'var(--font-tag)',
        fontStyle: {
            fontSize: 'var(--typography-tag-size)',
            fontWeight: 'var(--typography-tag-weight)',
            lineHeight: 'var(--typography-tag-line-height)',
            letterSpacing: 'var(--typography-tag-spacing)',
        },
    },
};
